/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const ValidationProblemDetails = zod.object({
  "type": zod.string().optional(),
  "title": zod.string().optional(),
  "status": zod.number().optional(),
  "detail": zod.string().optional(),
  "instance": zod.string().optional(),
  "errors": zod.record(zod.string(), zod.array(zod.string())).optional()
});

export type ValidationProblemDetails = zod.input<typeof ValidationProblemDetails>;
export type ValidationProblemDetailsOutput = zod.output<typeof ValidationProblemDetails>;
